import { TYPE_FIGURANT_NAME } from 'commons/constants';
import { DocumentType } from 'commons/constants/documents';
import { cpfMask, phoneMask } from 'commons/utils';
import { findDocument } from 'commons/utils/figurant';
import { IFigurant, IFiscal, IPet, IVehicle, StatusFigurant } from 'models';

export type PropsBuildAction = {
  onClick: (item: StatusFigurant) => void;
  text: string;
  getDescription: (name?: string) => string;
  fontSize: string;
};

const mountFigurantData = (item: IFigurant) => [
  { label: 'Tipo de figurante:', value: TYPE_FIGURANT_NAME[item.entityType as keyof typeof TYPE_FIGURANT_NAME] },
  { label: '', value: item?.agency?.name },
  { label: '', value: item?.genre === 'Nao_informado' ? 'Não Informado' : item?.genre },
  { label: 'CPF:', value: cpfMask(findDocument(item?.documents, DocumentType.CPF)?.documentContent) },
  { label: 'Telefone:', value: phoneMask(item?.phone) },
];

const mountFiscalData = (item: IFiscal) => [
  { label: '', value: item?.agency?.name },
  { label: '', value: item?.genre },
  { label: 'CPF:', value: cpfMask(item?.cpf) },
  { label: 'Telefone:', value: phoneMask(item?.phone) },
];

const mountAnimalData = (item: IPet) => [
  { label: 'Tipo de Animal:', value: item?.animalType },
  { label: 'Porte do Animal:', value: item?.animalSize },
  { label: '', value: item?.backgroundActors?.[0]?.agency?.name },
  { label: 'Tutor:', value: item?.backgroundActors?.[0]?.name },
  {
    label: 'CPF:',
    value: cpfMask(findDocument(item?.backgroundActors?.[0]?.documents, DocumentType.CPF)?.documentContent),
  },
  { label: 'Telefone:', value: phoneMask(item?.backgroundActors?.[0]?.phone) },
];

const mountVehicleData = (item: IVehicle) => [
  { label: 'Modelo:', value: item?.model },
  { label: 'Placa:', value: item?.plate?.toUpperCase() },
  { label: '', value: item?.backgroundActors?.[0]?.agency?.name },
  { label: 'Responsável:', value: item?.backgroundActors?.[0]?.name },
  {
    label: 'CPF:',
    value: cpfMask(findDocument(item?.backgroundActors?.[0]?.documents, DocumentType.CPF)?.documentContent),
  },
  { label: 'Telefone:', value: phoneMask(item?.backgroundActors?.[0]?.phone) },
];

const buildActionProps = (
  onClick: (item: StatusFigurant) => void,
  text: string,
  getDescription: (name?: string) => string,
  fontSize: string
): PropsBuildAction => ({
  onClick,
  text,
  getDescription,
  fontSize,
});

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 60,
      height: 60,
    },
    children: `${name?.split(' ')?.[0]?.[0]}${name?.split(' ')?.[1]?.[0] || name?.split(' ')?.[0]?.[0]}`,
  };
}

export { mountFigurantData, mountFiscalData, mountAnimalData, mountVehicleData, buildActionProps, stringAvatar };
